import type { FunctionComponent } from 'react'

import {
	eventHubService,
	PrimaryButton,
	trackingService,
} from '@monthio/react-components'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'

import type { WhitelabelSubdomainCase } from '../../../api/budgetApiClient'
import type { ClientInputs } from '../../../types'

import { budgetApiClient } from '../../../api/budgetApiClient'
import { authenticateWithApplicantId } from '../../../store/actions/authenticateActions'
import { goToFlow } from '../../../store/actions/flowEntryStatemachineActions'
import { StyledRegularButtonWrapper } from '../GenericLandingPageStyledComponent'
import { FlowLink } from './FlowLink'
import { FlowStatus } from './FlowStatus'

const StyledWrapper = styled.div`
	width: 100%;
	max-width: 100%;
`

export const CoupleSeparateDeviceStart: FunctionComponent<{
	children?: never
	clientInputs?: ClientInputs
}> = ({ clientInputs }) => {
	const dispatch = useDispatch()
	const { t } = useTranslation()
	const [caseData, setCaseData] = useState<WhitelabelSubdomainCase | null>(null)

	useEffect(() => {
		const createCase = async () => {
			const response = await budgetApiClient.createCaseWithSubdomainInfo(
				true,
				false,
				clientInputs,
			)
			setCaseData(response ?? null)
		}
		createCase()
	}, [])

	useEffect(() => {
		if (caseData != null) {
			dispatch(authenticateWithApplicantId(caseData?.mainApplicantId))
		}
	}, [caseData])

	const [coApplicantFinished, setCoApplicantFinished] = useState(false)

	useEffect(() => {
		if (caseData != null) {
			return eventHubService.subscribe<{ applicantId: string }>(
				'ApplicantSessionFinished',
				(payload) => {
					if (payload.applicantId === caseData?.secondaryApplicantId) {
						setCoApplicantFinished(true)
					}
				},
			)
		}
	}, [caseData?.secondaryApplicantId])

	return (
		<StyledWrapper>
			<FlowLink
				secondaryApplicantFlowUrl={caseData?.secondaryApplicantFlowUrl}
			/>
			<FlowStatus coApplicantFinished={coApplicantFinished} />
			<StyledRegularButtonWrapper>
				<PrimaryButton
					disabled={!coApplicantFinished}
					onClick={() => {
						const applicantId = caseData?.mainApplicantId
						if (applicantId != null) {
							trackingService.trackEvent('Finished genericLandingPage', {
								applicantId,
								coApplicantId: caseData?.secondaryApplicantId,
							})
							dispatch(goToFlow(applicantId))
						}
					}}
				>
					{t('generic-landing-page-start-btn')}
				</PrimaryButton>
			</StyledRegularButtonWrapper>
		</StyledWrapper>
	)
}
